import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Col, Modal, Row, Container, Dropdown, Alert, Form, Badge } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalList from '../../components/Modals/ModalList';
import ModalEntityViewer from '../../components/Modals/ModalEntityViewer';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import moment from 'moment';
import { WriteXml } from 'fattura-elettronica';
import { settings } from '../settings';
import { Editor } from '@tinymce/tinymce-react';
import FieldPreview from '../../components/Entity/FieldPreview';



export default function DGLTH_customer_order({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()
    const [statusPaymentOrderModal, setStatusPaymentOrderModal] = useState(false)
    const userInfo = LoginManager.getUserInfo();





    const [statusModalEntityViewerCustomerOrder, setStatusModalEntityViewerCustomerOrder] = useState(false)
    function closeModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(false)
    }
    function openModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(true)
    }

    function previewCustomerOrder(item) {
        navigate('/page/CustomerOrderPreview?id=' + item.id)
    }


    function newCustomerOrderPayment(item) {
        navigate('/entity/customer_order_payment/add', {
            state: {
                body: {
                    idCustomerOrder: item
                }
            }
        })
    }



    const [dataPaymentOrderModal, setDataPaymentOrderModal] = useState(false)
    async function showModalPaymentOrder(item) {
        setStatusPaymentOrderModal(true)

        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: item.id }]
        var response = await DataManager.searchItems('customer_order_payment', 1, 100, { 'field': 'id', 'order': 'desc' }, '', [], constraints)
        if (response.success === 1) {
            setDataPaymentOrderModal(response.body)
            console.warn(response.body)
        }
    }
    function closeModalPaymentOrder() {
        setStatusPaymentOrderModal(false)
        setDataPaymentOrderModal(null)
    }

    function goToPreview() {
        navigate('/page/PaymentsPreview?id=' + item.id)
    }


    const [statusModalRowsDelivery, setStatusModalRowsDelivery] = useState(false)
    const [order, setOrder] = useState(null)
    const [selectedIdsRow, setSelectedIdsRow] = useState([]);
    const selectAllDeliveryRef = useRef(null);

    const deliveryRows = useMemo(() => {
        if (!order || !Array.isArray(order.rows)) {
            return [];
        }
        return order.rows.filter((row) => {
            if (!row || row.id === undefined || row.id === null) {
                return false;
            }
            const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value);
            return String(statusValue || '').toUpperCase() === '10_RECEIVED';
        });
    }, [order]);

    const selectableDeliveryRowIds = useMemo(() => deliveryRows.map((row) => row.id), [deliveryRows]);

    useEffect(() => {
        setSelectedIdsRow((prev) => prev.filter((id) => selectableDeliveryRowIds.includes(id)));
    }, [selectableDeliveryRowIds]);

    const allDeliveryRowsSelected = selectableDeliveryRowIds.length > 0 && selectableDeliveryRowIds.every((id) => selectedIdsRow.includes(id));
    const isDeliverySelectAllIndeterminate = selectedIdsRow.length > 0 && !allDeliveryRowsSelected;

    useEffect(() => {
        if (selectAllDeliveryRef.current) {
            selectAllDeliveryRef.current.indeterminate = isDeliverySelectAllIndeterminate;
        }
    }, [isDeliverySelectAllIndeterminate]);

    const [statusModalSupplierOrders, setStatusModalSupplierOrders] = useState(false)
    const [supplierOrderDetail, setSupplierOrderDetail] = useState(null)
    const [supplierGroups, setSupplierGroups] = useState([])
    const [rowsWithoutSupplier, setRowsWithoutSupplier] = useState([])
    const [creatingSupplierOrderId, setCreatingSupplierOrderId] = useState(null)
    const [supplierOrderModalStatus, setSupplierOrderModalStatus] = useState(false)
    const [supplierOrderInitData, setSupplierOrderInitData] = useState(null)
    const [activeSupplierGroupId, setActiveSupplierGroupId] = useState(null)
    const [activeSupplierGroupRows, setActiveSupplierGroupRows] = useState([])

    const [deliveryCompilerStatus, setDeliveryCompilerStatus] = useState(false)
    const [deliveryCompilerData, setDeliveryCompilerData] = useState(null)

    const handleToggleAllDeliveryRows = (checked) => {
        if (checked) {
            setSelectedIdsRow(Array.from(selectableDeliveryRowIds));
        }
        else {
            setSelectedIdsRow([]);
        }
    };

    const handleCheck = (id, checked) => {
        if (!selectableDeliveryRowIds.includes(id)) {
            return;
        }

        if (checked) {
            setSelectedIdsRow((prev) => (prev.includes(id) ? prev : [...prev, id]));
        }
        else {
            setSelectedIdsRow((prev) => prev.filter((item) => item !== id));
        }
    };


    function closeModalRowsDelivery() {
        setStatusModalRowsDelivery(false)
        setSelectedIdsRow([])
    }
    async function openModalRowsDelivery(item) {
        setSelectedIdsRow([])
        var res = await DataManager.getItem('customer_order', item.id);
        if (res.success === 1) {
            setOrder(res.body[0])
            setStatusModalRowsDelivery(true)
        } else {
            toast.error(res.message, { theme: 'colored' })
        }

    }
    async function createDelivery() {
        if (selectedIdsRow.length === 0) {
            toast.warning('Seleziona almeno una riga da consegnare.', { theme: 'colored' })
            return
        }

        var rows = [];
        for (let i = 0; i < selectedIdsRow.length; i++) {
            var filtered = order?.rows?.find(item => item.id === selectedIdsRow[i]);
            console.warn(filtered)
            var row = {
                idCustomerOrderRow: { id: selectedIdsRow[i] },
                name: filtered.name,
                description: filtered.description,
                supplier: filtered.idSupplier && filtered.idSupplier.name,
                quantity: filtered.quantity,
                status: {
                    value: '0_PENDING',
                    label: '0_PENDING'
                }
            }
            rows.push(row);
        }
        console.log(order)
        var body = {
            idCustomerOrder: order,
            status: { value: '10_CREATED', label: '10_CREATED' },
            deliveryDate: order.deliveryDate,
            idUserDelivery: order.idUserDelivery ?? null,
            realDeliveryDate: order.realDeliveryDate,
            finishDeliveryDate: order.finishDeliveryDate,
            deliveryAddress: order.deliveryAddress,
            latitude: order.latitude,
            longitude: order.longitude,
            locality: order.locality,
            rows: rows
        }
        console.log(body)
        setDeliveryCompilerData(body)
        setDeliveryCompilerStatus(true)
        closeModalRowsDelivery()
    }


    function closeModalSupplierOrders() {
        setStatusModalSupplierOrders(false)
        setSupplierOrderDetail(null)
        setSupplierGroups([])
        setRowsWithoutSupplier([])
        setCreatingSupplierOrderId(null)
        closeSupplierOrderCompiler()
    }

    function closeDeliveryCompiler() {
        setDeliveryCompilerStatus(false)
        setDeliveryCompilerData(null)
    }

    async function saveDelivery(data) {
        if (!data) {
            return
        }
        try {
            const response = await DataManager.insertItem('customer_order_delivery', data)
            if (response.success !== 1) {
                toast.error(response.message || 'Impossibile creare la consegna.', { theme: 'colored' })
                return
            }

            const deliveryRows = Array.isArray(data.rows) ? data.rows : []
            for (let i = 0; i < deliveryRows.length; i++) {
                const row = deliveryRows[i]
                const rowId = (row?.idCustomerOrderRow && row.idCustomerOrderRow.id) || row?.idCustomerOrderRow
                if (!rowId) {
                    continue
                }
                const update = await DataManager.updateItem('customer_order_row', { status: { value: '15_IN_DELIVERY', label: '15_IN_DELIVERY' } }, rowId)
                if (update.success !== 1) {
                    throw new Error(update.message || 'Impossibile aggiornare lo stato della riga ordine cliente.')
                }
            }

            toast.success('Creazione consegna avvenuta con successo.', { theme: 'colored' })
            if (typeof refreshData === 'function') {
                refreshData()
            }
            closeDeliveryCompiler()
        }
        catch (error) {
            toast.error(error.message || 'Impossibile creare la consegna.', { theme: 'colored' })
        }
    }

    function closeSupplierOrderCompiler() {
        setSupplierOrderModalStatus(false)
        setSupplierOrderInitData(null)
        setActiveSupplierGroupId(null)
        setCreatingSupplierOrderId(null)
        setActiveSupplierGroupRows([])
    }

    const buildSupplierGroups = (orderDetails) => {
        if (!orderDetails || !Array.isArray(orderDetails.rows)) {
            setSupplierGroups([])
            setRowsWithoutSupplier([])
            return
        }

        const existingOrders = new Set()
        if (Array.isArray(orderDetails.supplier_orders)) {
            orderDetails.supplier_orders.forEach((supplierOrder) => {
                if (supplierOrder && supplierOrder.idSupplier && supplierOrder.idSupplier.id) {
                    existingOrders.add(supplierOrder.idSupplier.id)
                }
            })
        }

        const groupsMap = new Map()
        const missingSupplierRows = []

        orderDetails.rows.forEach((row) => {
            if (row && row.idSupplier && row.idSupplier.id) {
                const supplierId = row.idSupplier.id
                if (!groupsMap.has(supplierId)) {
                    groupsMap.set(supplierId, {
                        supplier: row.idSupplier,
                        rows: [],
                        alreadyCreated: existingOrders.has(supplierId)
                    })
                }
                groupsMap.get(supplierId).rows.push(row)
            }
            else {
                missingSupplierRows.push(row)
            }
        })

        setSupplierGroups(Array.from(groupsMap.values()))
        setRowsWithoutSupplier(missingSupplierRows)
    }

    async function openModalSupplierOrders(orderItem) {
        var res = await DataManager.getItem('customer_order', orderItem.id);
        if (res.success === 1 && res.body && res.body.length > 0) {
            const orderDetails = res.body[0]
            setSupplierOrderDetail(orderDetails)
            buildSupplierGroups(orderDetails)
            setStatusModalSupplierOrders(true)
        }
        else {
            toast.error(res.message || 'Impossibile recuperare i dettagli dell\'ordine.', { theme: 'colored' })
        }
    }

    function openSupplierOrderCompilerForGroup(group) {
        if (!supplierOrderDetail || !group || !group.supplier || group.alreadyCreated) {
            return
        }

        const rows = group.rows.map((row) => ({
            name: row.name || '',
            description: row.description || '',
            quantity: row.quantity ?? 0,
            notes: row.notes || '',
            listPriceOrder: null,
            discountPercentage: row.discountPercentage ?? 0,
            discount: row.discount ?? 0,
            idCustomerOrderRow: row.id,
            status: {
                value: '0_PENDING',
                label: '0_PENDING'
            }
        }))

        const body = {
            idSupplier: group.supplier,
            idCustomerOrder: {
                id: supplierOrderDetail.id,
                internalCode: supplierOrderDetail.internalCode || ''
            },
            customerName: supplierOrderDetail.idCustomer && supplierOrderDetail.idCustomer.name,
            internalCode: '',
            externalCode: '',
            status: {
                value: '1_TO_SEND',
                label: '1_TO_SEND'
            },
            paymentNotes: '',
            requested_delivery_date: null,
            notes: '',
            file: null,
            deliveryDate: null,
            rows: rows
        }

        setSupplierOrderInitData(body)
        setActiveSupplierGroupId(group.supplier.id)
        setActiveSupplierGroupRows(group.rows)
        setSupplierOrderModalStatus(true)
    }

    async function saveSupplierOrder(data) {
        if (!data || !activeSupplierGroupId) {
            return
        }

        setCreatingSupplierOrderId(activeSupplierGroupId)

        try {
            const response = await DataManager.insertItem('supplier_order', data)
            if (response.success !== 1) {
                toast.error(response.message || 'Impossibile creare l\'ordine fornitore.', { theme: 'colored' })
                return
            }

            const supplierName = data.idSupplier && data.idSupplier.name ? data.idSupplier.name : 'fornitore'

            if (Array.isArray(activeSupplierGroupRows) && activeSupplierGroupRows.length > 0) {
                await Promise.all(activeSupplierGroupRows.map(async (row) => {
                    if (!row || !row.id) {
                        return
                    }
                    const updateRow = await DataManager.updateItem('customer_order_row', { status: { value: '5_ORDERED' } }, row.id)
                    if (updateRow.success !== 1) {
                        throw new Error(updateRow.message || 'Aggiornamento riga ordine cliente non riuscito.')
                    }
                }))
            }

            let updatedOrder = supplierOrderDetail
            const orderCheck = await DataManager.getItem('customer_order', supplierOrderDetail.id)
            if (orderCheck.success === 1 && orderCheck.body && orderCheck.body.length > 0) {
                updatedOrder = orderCheck.body[0]
                setSupplierOrderDetail(updatedOrder)
                const allOrdered = Array.isArray(updatedOrder.rows) && updatedOrder.rows.length > 0 && updatedOrder.rows.every((row) => row.status && row.status.value === '5_ORDERED')
                if (allOrdered) {
                    await DataManager.updateItem('customer_order', { status: { value: '2_TO_ORDER' } }, updatedOrder.id)
                }
            }

            toast.success(`Ordine per ${supplierName} creato con successo.`, { theme: 'colored' })
            setSupplierGroups((prev) => prev.map((el) => {
                if (el.supplier && el.supplier.id === activeSupplierGroupId) {
                    return { ...el, alreadyCreated: true }
                }
                return el
            }))
            if (typeof refreshData === 'function') {
                refreshData()
            }
            closeSupplierOrderCompiler()
        }
        catch (error) {
            toast.error(error.message || 'Si è verificato un errore durante la creazione dell\'ordine fornitore.', { theme: 'colored' })
        }
        finally {
            setCreatingSupplierOrderId(null)
        }
    }







    if (entity !== null) {
        return (
            <>

                <div className='d-flex'>
                    {item?.status?.value === '0_PENDING' ? (
                        <>
                            <Button size='sm' variant='outline-warning' onClick={() => openModalSupplierOrders(item)} className='py-0 me-1'>Ordini fornitore</Button>

                        </>
                    ) : null}
                    {item?.deliveryAvaiable === 1  ? (
                        <>
                            <Button size='sm' variant='outline-primary' onClick={() => openModalRowsDelivery(item)} className='py-0 me-1'>Crea consegna</Button>
                        </>
                    ) : null}
                    {/* {item?.status?.value === '1_ORDERED' || item?.status?.value === '7_READY_FOR_DELIVERY'  ? (
                        <>
                            <Button size='sm' variant='outline-primary' onClick={() => openModalRowsDelivery(item)} className='py-0 me-1'>Crea consegna</Button>
                        </>
                    ) : null} */}
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-secondary" size='sm'>
                            Azioni
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => showModalPaymentOrder(item)} className='py-0'>Storico pagamenti</Dropdown.Item>
                            <Dropdown.Item onClick={() => newCustomerOrderPayment(item)} className='py-0'>Registra pagamento</Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                    <Button onClick={() => previewCustomerOrder(item)} size="sm" variant="outline-secondary" className='ms-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>
                </div>


                {statusModalEntityViewerCustomerOrder !== false && (
                    <ModalEntityViewer entity={'customer_order'} item={item} status={statusModalEntityViewerCustomerOrder} closeModal={closeModalEntityViewerCustomerOrder} />
                )}
                {statusPaymentOrderModal ? (
                    <>
                        <Modal show={statusPaymentOrderModal} onHide={closeModalPaymentOrder} size='lg' scrollable>
                            <Modal.Header closeButton>
                                <Modal.Title>Storico pagamenti</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? (
                                    <Table className='table small'>
                                        <thead>
                                            <tr>
                                                <th>Data pagamento</th>
                                                <th>Importo pagato</th>
                                                <th>Stato</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataPaymentOrderModal.map((payment, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{moment(payment.paymentDate).format('DD/MM/YYYY')}</td>
                                                        <td>{payment.totalPayment} €</td>
                                                        <td>{payment.status && payment.status.value && payment.status.value === "0_PENDING" ? "In attesa" : "Generato"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <Alert>Nessun pagamento presente.</Alert>
                                )}

                                <p className='text-end'>Totale ordine: <b>{item.totalPrice} €</b></p>
                                <p className='text-end'>Totale pagato: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0) : 0} €</b></p>
                                <p className='text-end'>Rimanente: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? parseFloat(item.totalPrice - dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0)).toFixed(2) : parseFloat(item.totalPrice).toFixed(2)} €</b></p>
                            </Modal.Body>
                            <Modal.Footer>
                                {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? <Button variant="outline-secondary" onClick={() => goToPreview()}>
                                    Anteprima di stampa
                                </Button> : null}

                                <Button variant="secondary" onClick={closeModalPaymentOrder}>
                                    Chiudi
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                ) : <></>}



                <Modal show={statusModalRowsDelivery} onHide={closeModalRowsDelivery} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Seleziona righe</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 40 }}>
                                                <Form.Check
                                                    ref={selectAllDeliveryRef}
                                                    type='checkbox'
                                                    disabled={selectableDeliveryRowIds.length === 0}
                                                    checked={allDeliveryRowsSelected}
                                                    onChange={(event) => handleToggleAllDeliveryRows(event.target.checked)}
                                                />
                                            </th>
                                            <th>Nome</th>
                                            <th>Stato</th>
                                            <th>Fornitore</th>
                                            <th>Quantità</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {deliveryRows.length === 0 ? (
                                            <tr>
                                                <td colSpan={5} className='text-center text-muted'>Nessuna riga pronta per la consegna.</td>
                                            </tr>
                                        ) : (
                                            deliveryRows.map((element) => {
                                                const rawStatus = typeof element?.status === 'string' ? element.status : element?.status?.value
                                                const statusLabel = rawStatus ? LanguageProvider.getLabel('customer_order_row', `status.options.${rawStatus}`) : '-'
                                                return (
                                                    <tr key={element.id}>
                                                        <td>
                                                            <Form.Check
                                                                type="checkbox"
                                                                id={`row-${element.id}`}
                                                                checked={selectedIdsRow.includes(element.id)}
                                                                onChange={(e) => handleCheck(element.id, e.target.checked)}
                                                            />
                                                        </td>
                                                        <td>{element.name ?? "-"}</td>
                                                        <td>{statusLabel || '-'}</td>
                                                        <td>{element.idSupplier?.name ?? "-"}</td>
                                                        <td>{element.quantity ?? 0}</td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={() => closeModalRowsDelivery()}>Indietro</Button>
                        <Button variant='primary' onClick={() => createDelivery()} disabled={selectedIdsRow.length === 0}>Crea consegna</Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={statusModalSupplierOrders} onHide={closeModalSupplierOrders} size='lg' scrollable>
                    <Modal.Header closeButton>
                        <Modal.Title>Ordini fornitore</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {rowsWithoutSupplier.length > 0 ? (
                            <Alert variant='warning'>
                                <p className='mb-2'>Alcune righe non hanno un fornitore associato e non possono essere incluse in un ordine:</p>
                                <ul className='mb-0'>
                                    {rowsWithoutSupplier.map((row, index) => (
                                        <li key={row?.id || index}>
                                            {row?.code ? `${row.code} - ` : ''}{row?.name || 'Articolo senza nome'}
                                        </li>
                                    ))}
                                </ul>
                            </Alert>
                        ) : null}

                        {supplierGroups.length > 0 ? (
                            supplierGroups.map((group, index) => (
                                <div key={group?.supplier?.id || index} className='mb-4'>
                                    <div className='d-flex justify-content-between align-items-center mb-2'>
                                        <h6 className='mb-0'>Fornitore: {group?.supplier?.name || '---'}</h6>
                                    </div>
                                    <Table bordered size='sm' responsive>
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Quantità</th>
                                                <th>Prezzo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {group.rows.map((row) => {
                                                const rawPrice = row.price ?? row.listPriceOrder ?? 0
                                                const displayPrice = !Number.isNaN(parseFloat(rawPrice)) ? parseFloat(rawPrice).toFixed(2) : rawPrice
                                                return (
                                                    <tr key={row.id}>
                                                        <td>{row.name || '-'}</td>
                                                        <td>{row.quantity ?? 0}</td>
                                                        <td>{displayPrice}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                    <div className='text-end'>
                                        <Button
                                            variant={group.alreadyCreated ? 'success' : 'primary'}
                                            size='sm'
                                            className='mt-2'
                                            disabled={group.alreadyCreated || creatingSupplierOrderId === (group?.supplier?.id || null)}
                                            onClick={() => openSupplierOrderCompilerForGroup(group)}
                                        >
                                            {group.alreadyCreated ? "Ordine già creato" : `Crea ordine fornitore ${group?.supplier?.name || ''}`}
                                        </Button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <Alert variant='secondary'>Nessuna riga disponibile per creare ordini fornitore.</Alert>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={closeModalSupplierOrders}>Chiudi</Button>
                    </Modal.Footer>
                </Modal>


                <ModalEntityCompiler
                    entity={'supplier_order'}
                    initData={supplierOrderInitData}
                    close={closeSupplierOrderCompiler}
                    status={supplierOrderModalStatus}
                    confirmCallback={saveSupplierOrder}
                />

                <ModalEntityCompiler
                    entity={'customer_order_delivery'}
                    initData={deliveryCompilerData}
                    close={closeDeliveryCompiler}
                    status={deliveryCompilerStatus}
                    confirmCallback={saveDelivery}
                />



            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
